import React from "react"
import { useMap } from "@vis.gl/react-google-maps"
import { ZonesMapProps } from "./ZonesMapMapbox"
import { useGoogleMapsEffect } from "../lib/hooks/useGoogleMapsEffect"
import DrawingPolygonManager from "../gmaps/DrawingPolygonManager"
import GMap from "../gmaps/GMap"
import ZoneLayer from "../gmaps/ZoneLayer"
import { useDropZonePaintGetter } from "../lib/hooks/useDropZoneStyle"
import { useGoogleMapsInitBounds } from "../lib/hooks/useGoogleMapsInitBounds"

const MAP_ID = "zones-gmap"

const ZonesMapGoogleMap: React.FC<ZonesMapProps> = ({
  type,
  filteredZones,
  bbox,
  editableZone,
  handleDrawCreate,
  handleDrawUpdate,
  isCreating,
  setSelectedZone,
  selectedZone,
}) => {
  const initialBounds = useGoogleMapsInitBounds(bbox!)

  const gMap = useMap(MAP_ID)

  const getZonePaint = useDropZonePaintGetter({ isZoneMap: true })

  // clear prev zones when type changes
  useGoogleMapsEffect(MAP_ID, () => gMap?.data?.forEach((gMapFeature) => gMap.data.remove(gMapFeature)), [
    type,
  ])

  return (
    <GMap
      mapId={MAP_ID}
      initialBounds={initialBounds}
      containerStyle={{
        height: "100%",
        width: "100%",
      }}
      onClick={() => setSelectedZone(undefined)}
      shareCurrentView
    >
      <ZoneLayer
        mapId={MAP_ID}
        zones={filteredZones}
        showZones={true}
        onClick={(zone) => setSelectedZone(zone)}
        properties={{
          zoneType: type,
        }}
        layerStyle={(feature: google.maps.Data.Feature) => {
          const uuid = feature.getProperty("uuid")
          const isSelected = selectedZone?.uuid === uuid || false
          const { fillColor, fillOpacity, lineColor } = getZonePaint({ type, isSelected })
          return {
            fillColor,
            fillOpacity,
            strokeWeight: isSelected ? 2 : 1,
            strokeColor: lineColor,
          }
        }}
      />

      <DrawingPolygonManager
        mapId={MAP_ID}
        isCreating={isCreating}
        editableZone={editableZone}
        onCreateFinish={(id, coords) => handleDrawCreate({ id, coords })}
        onEditFinish={(coords) => handleDrawUpdate(coords)}
      />
    </GMap>
  )
}

export default ZonesMapGoogleMap
